import React from 'react'
import Image from 'next/image'

export const Marketing = () => (
	<div className='novosti-text' style={{ textAlign: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;' }}>
		<p style={{ lineHeight: 1.6, color: '#333', fontSize: '16px' }}>
			U okviru brenda <a href="https//oglasi.me" style={{ color: '#000', textDecoration: 'none', fontWeight: 600, fontSize: '16px' }}>Oglasi.me</a> i <a href='https://autodiler.me' style={{ color: '#000', textDecoration: 'none', fontWeight: 600, fontSize: '16px' }}>AutoDiler.me</a> nudimo reklamiranje na sajtu, aplikaciji i
			društvenim mrežama. Za više detalja, kontaktirajte nas.
		</p>

		<p style={{ marginBottom: 0, lineHeight: 1.6, color: '#333' }}><strong style={{ color: '#54317E', fontWeight: 'bolder' }}>KONTAKT TELEFONI</strong></p>
		<a href='tel:+38267733941' style={{ color: '#000', textDecoration: 'none', fontWeight: 600, fontSize: '2rem' }}>+382 (0)67 733 941</a>
		<br/>
		<a href='tel:+38230550099' style={{ color: '#000', textDecoration: 'none', fontWeight: 600, fontSize: '2rem' }}>+382 (0)30 550 099</a>

		<br/>
		<p style={{ marginBottom: 0, lineHeight: 1.6, color: '#333' }}><strong style={{ color: '#54317E', fontWeight: 'bolder' }}>EMAIL</strong></p>
		<a href='mailto:info@oglasi.me' style={{ color: '#000', textDecoration: 'none', fontWeight: 600, fontSize: '2rem' }}>info@oglasi.me</a>
	</div>
)
